"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClassAttachmentListsFromMechanics = exports.createClassDetailMechanics = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const attachmentRateLimitEvaluator_1 = require("./attachmentRateLimitEvaluator");
const createClassDetailMechanics = (params) => {
    const { classDetails, f1EngineMode } = params;
    const attachmentRateLimitEvaluator = (0, attachmentRateLimitEvaluator_1.createAttachmentRateLimitEvaluator)({
        classDetails,
        f1EngineMode,
    });
    const _generateRequiredFields = () => {
        const outputFields = [];
        const attachmentRateFormulas = classDetails.map((cd) => {
            // Note that there's currently only one config option for
            // attachment rate limit so can simply set it as is.
            // If we introduce other interfaces, will need to update this
            return cd.attachmentRateLimit._config_.config.formula;
        });
        // Evaluate all formulas and their composition (what fields are used).
        // This way we can better optimize engine calculations and apply more
        // specific validations
        const allNonRangeVariableSet = new Set();
        const allRangeVariableSet = new Set();
        for (const formula of attachmentRateFormulas) {
            const { nonRangeVariables, rangeVariables } = (0, formula_engine_1.getFormulaComposition)(formula);
            nonRangeVariables.forEach((ipt) => allNonRangeVariableSet.add(ipt));
            rangeVariables.forEach((ipt) => allRangeVariableSet.add(ipt));
        }
        // Currently not supporting receivable-level fields within formulas for
        // attachment rate limit evaluation, only allowing ranged variables.
        // This makes sense as attachment rate limit is not at a receivable level
        // and is meant to resolve to a single number.
        // Can revisit this if need to factor in specific receivable fields
        const allNonRangeVariables = Array.from(allNonRangeVariableSet);
        (0, common_1.finleyAssert)(allNonRangeVariables.length === 0, `Attachment Rate Limit formulas currently do not support receivable-specific fields [fields:${allNonRangeVariables.join(', ')}]`);
        // Sanitize ranged variables so they can represent the fields in receivable
        // structure, as fields don't have "_RANGE" suffix, only formula has it that way
        for (const rangeVariable of allRangeVariableSet) {
            outputFields.push((0, formula_engine_1.extractVariableNameFromRange)(rangeVariable));
        }
        return outputFields;
    };
    const requiredFields = _generateRequiredFields();
    const sanitizeAttachmentReceivable = (sanitizeParams) => {
        const { receivable } = sanitizeParams;
        return _.pick(receivable, requiredFields);
    };
    const initializeAttachmentRateLimitEvaluate = (initializeParams) => {
        attachmentRateLimitEvaluator.initializeEngine(initializeParams);
    };
    const evaluateAttachmentRateLimit = (evaluateParams) => {
        const { formula } = evaluateParams;
        const attachmentRateLimit = attachmentRateLimitEvaluator.evaluateConfig({
            formula,
        });
        return attachmentRateLimit;
    };
    const cleanUp = () => {
        attachmentRateLimitEvaluator.tearDownEngine();
    };
    return {
        classDetails,
        sanitizeAttachmentReceivable,
        initializeAttachmentRateLimitEvaluate,
        evaluateAttachmentRateLimit,
        cleanUp,
    };
};
exports.createClassDetailMechanics = createClassDetailMechanics;
const createClassAttachmentListsFromMechanics = (params) => {
    const { classDetailMechanics } = params;
    const classAttachmentLimits = [];
    let priorAttachmentRate = 0;
    for (const classDetail of classDetailMechanics.classDetails) {
        const classLabel = classDetail.classLabel.value;
        // Note that there's currently only one config option for
        // attachment rate limit so can simply set it as is.
        // If we introduce other interfaces, will need to update this
        const formula = classDetail.attachmentRateLimit._config_.config.formula;
        const result = classDetailMechanics.evaluateAttachmentRateLimit({
            formula,
        });
        const { attachmentRateLimit } = result;
        // Current rate can not be less than prior ones (can only increase)
        (0, common_1.finleyAssert)(attachmentRateLimit >= priorAttachmentRate, `Class Attachment Rate Limits must increase monotonically. After evaluating, came across [current:${attachmentRateLimit}] [prior:${priorAttachmentRate}] [classLabel:${classLabel}]`);
        classAttachmentLimits.push({ classLabel, attachmentRateLimit });
        priorAttachmentRate = attachmentRateLimit;
    }
    return classAttachmentLimits;
};
exports.createClassAttachmentListsFromMechanics = createClassAttachmentListsFromMechanics;
//# sourceMappingURL=classDetailMechanics.js.map